import hotel from "./user"

export const hotelReducers = {
  hotel: hotel.reducer
}
